import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { useShop } from "@/store";
import { P, M } from "@/data/catalogue";
import ProductCard from "@/components/ProductCard";
import PageHd from "@/components/PageHd";
import { Reveal } from "@/components/motion";

const CHIPS = ["all", "one", "new", "neutral", "color", "black"];

export default function Shop() {
  const { t } = useShop();
  const [params, setParams] = useSearchParams();
  const f = params.get("f") || "all";
  const sort = params.get("s") || "feat";

  let list = P.filter((p) => f === "all" || (f === "one" && p.one) || (f === "new" && p.isNew) || p.tags.includes(f));
  if (sort === "lo") list = [...list].sort((a, b) => a.price - b.price);
  if (sort === "hi") list = [...list].sort((a, b) => b.price - a.price);

  const setF = (c) => setParams(c === "all" && sort === "feat" ? {} : { ...(c !== "all" ? { f: c } : {}), ...(sort !== "feat" ? { s: sort } : {})});

  return (
    <>
      <PageHd eb={t("shop.eb")} h={t("shop.h")} p={t("shop.p")} testid="shop-title" />
      <div className="wrap" style={{ paddingBottom: 40 }}>
        <div className="shophead">
          <div className="filters" role="group" aria-label="Filters">
            {CHIPS.map((c) => (
              <button key={c} className={`chip${f === c ? " on" : ""}`} data-testid={`filter-${c}`} onClick={() => setF(c)}>
                {t(`shop.${c}`)}
              </button>
            ))}
          </div>
          <div style={{ display: "flex", gap: 22, alignItems: "center" }}>
            <span className="count" data-testid="shop-count">{list.length} {t("shop.n")}</span>
            <select
              className="sel"
              data-testid="sort-select"
              aria-label={t("shop.sort")}
              value={sort}
              onChange={(e) => setParams({ ...(f !== "all" ? { f } : {}), ...(e.target.value !== "feat" ? { s: e.target.value } : {}) })}
            >
              <option value="feat">{t("shop.feat")}</option>
              <option value="lo">{t("shop.lo")}</option>
              <option value="hi">{t("shop.hi")}</option>
            </select>
          </div>
        </div>
        {list.length ? (
          <div className="grid g4" data-testid="shop-grid">
            {list.map((p, i) => (
              <motion.div key={p.id} layout initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: i * 0.04 }}>
                <ProductCard p={p} />
              </motion.div>
            ))}
          </div>
        ) : (
          <p className="empty" data-testid="shop-empty">{t("shop.none")}</p>
        )}
      </div>
      <section className="sec">
        <div className="wrap split">
          <Reveal>
            <div className="eyebrow">{t("art.crafted")}</div>
            <h2 style={{ fontSize: "clamp(30px,3.6vw,46px)" }}>{t("art.crafted")}</h2>
            <p className="lede">{t("art.craftedT")}</p>
            <div style={{ marginTop: 22 }}>
              <Link className="btn ghost" to="/artisans">{t("hero.b2")} →</Link>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="im"><img src={M.steps} alt="Four Wayuu bags on sandstone steps" loading="lazy" /></div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
